import React from 'react';
import {Container, Row, Col, Figure} from 'react-bootstrap';
import './Home.css';

const  Railways = () => {
    return ( 
        <Container>
  <Row>
    <Col xs={12} md={12}>
    <Figure className="itemsimg">
    <Figure.Caption>
  <p><h2><span className="fontcolor">PARTS AGGREGATE & RAILWAY EQUIPMENT</span></h2></p>
            <p><h4>BUK is a supplier of parts and Railway Equipment.</h4></p>
  </Figure.Caption>
  <Figure.Image
    width={850}
    height={850}
    alt="171x180"
    src="https://res.cloudinary.com/dr0cgsqke/image/upload/v1611596769/nonedb/Railway_k0xqfu.jpg"
  />
  <Figure.Caption>
    
  </Figure.Caption>
</Figure>  
      
    </Col>
  </Row>
  <Row>
    <Col xs={12} md={12}>
    
    <Figure className="itemsimg">
  <Figure.Image
    width={850}
    height={850}
    alt="171x180"
    src="https://res.cloudinary.com/dr0cgsqke/image/upload/v1611596766/nonedb/Railway_2_ud0o6o.jpg"
  />
  <Figure.Caption>
  
  </Figure.Caption>
</Figure>  
    </Col>
  </Row>
</Container>
     );
};
 
export default Railways;